export const apiHost = import.meta.env.VITE_APP_CORE_HOST;
export const s3BucketUrl = import.meta.env.VITE_APP_S3_BUCKET;